import { useFormContext } from './form';
import { Checkbox } from 'material-ui';
import React from 'react';

const styles = {
    checkbox: {
        marginTop: '30px',
    },
};

export function FormCheckbox({ name, ...rest }) {
    const form = useFormContext();
    const conf = form.config[name] || {};
    const value = form.values[name];

    return (
        <Checkbox
            label={conf.label}
            checked={value}
            onCheck={e => form.onChange({ field: name, value: e.target.checked })}
            style={styles.checkbox}
            {...rest}
        />
    );
}



// WEBPACK FOOTER //
// ./app/components/common/Form/FormCheckbox.jsx